import {
  Grid,
  Tab,
  Tabs,
  Stack,
  Box,
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Popover,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import MainCard from "../../../components/MainCard";
import { useAppContext } from "../../../context/AppContext";
import Summary from "./Summary";
import AllRequestsReport from "./AllRequestsReport";
import FailedTestsReport from "./FailedTestsReport";
import SkippedTestsReport from "./SkippedTestsReport";
import FilterListIcon from "@mui/icons-material/FilterList";

const APIReport = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const { totalTestCases, iteration, isLoading } = useAppContext();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [sortOrder, setSortOrder] = useState("default");
  const [anchorEl, setAnchorEl] = useState(null);

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [searchQuery]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleClearFilters = () => {
    setStatusFilter("All");
    setSortOrder("default");
    handleFilterClose();
  };

  const handleNavigateToRequests = (filterStatus) => {
    setStatusFilter(filterStatus);
    setCurrentTab(1); 
  };

  const openFilter = Boolean(anchorEl);
  const id = openFilter ? "simple-popover" : undefined;

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  return (
    <>
      <Grid item xs={12}>
        <MainCard content={false}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pr: 2,
            }}>
            <Tabs
              value={currentTab}
              onChange={handleChange}
              sx={{
                "& .MuiTab-root": {
                  fontSize: "1rem", // Increased font size
                },
              }}>
              <Tab label="Summary" index={0} />
              <Tab label="All Requests" index={1} />
              <Tab label="Failed Tests" index={2} />
              <Tab label="Skipped Tests" index={3} />
            </Tabs>
            {currentTab === 1 && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search..."
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      height: 32,
                      fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                      top: -5,
                      fontSize: "0.875rem",
                    },
                  }}
                />
                <Tooltip title="Filter list">
                  <IconButton onClick={handleFilterClick}>
                    <FilterListIcon />
                  </IconButton>
                </Tooltip>
                <Popover
                  id={id}
                  open={openFilter}
                  anchorEl={anchorEl}
                  onClose={handleFilterClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}>
                  <Box sx={{ p: 2, minWidth: 250 }}>
                    <Stack spacing={2} direction="column">
                      <TextField
                        select
                        label="Status"
                        fullWidth
                        size="small"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}>
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Pass">Pass</MenuItem>
                        <MenuItem value="Fail">Fail</MenuItem>
                      </TextField>
                      <TextField
                        select
                        label="Sort by Execution Time"
                        fullWidth
                        size="small"
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}>
                        <MenuItem value="default">Default</MenuItem>
                        <MenuItem value="asc">Time: Low to High</MenuItem>
                        <MenuItem value="desc">Time: High to Low</MenuItem>
                      </TextField>
                      <Button
                        variant="outlined"
                        color="secondary"
                        fullWidth
                        onClick={handleClearFilters}>
                        Clear Filters
                      </Button>
                    </Stack>
                  </Box>
                </Popover>
              </Box>
            )}
          </Box>
        </MainCard>
      </Grid>
      {currentTab === 0 && (
        <Grid item xs={12}>
          <Summary
            isLoading={isLoading}
            iteration={iteration}
            totalTestCases={totalTestCases}
            onNavigateToRequests={handleNavigateToRequests}
          />
        </Grid>
      )}
      {currentTab === 1 && (
        <Grid item xs={12}>
          <AllRequestsReport
            iterationId={iteration?._id}
            totalCount={totalTestCases}
            isLoading={isLoading}
            searchQuery={debouncedSearchQuery}
            sortOrder={sortOrder}
            statusFilter={statusFilter}
          />
        </Grid>
      )}
      {currentTab === 2 && (
        <Grid item xs={12}>
          <FailedTestsReport isLoading={isLoading} />
        </Grid>
      )}
      {currentTab === 3 && (
        <Grid item xs={12}>
          <SkippedTestsReport />
        </Grid>
      )}
    </>
  );
};

export default APIReport;
